import { usePageTitle } from 'hooks'

const PageTitle = ({ view, detail, description = '' }) => {
  usePageTitle({
    view,
    detail,
    description
  })

  return null
}

export default PageTitle
